import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m16.933 3.293 3.33.498a.75.75 0 0 1 .631.853.75.75 0 0 1-.853.631l-3.201-.479-3.321.679c-.43.15-.69.245-.877.374-.137.095-.221.197-.255.425a.8.8 0 0 1-.046.164l.163.156c.271.285.484.641.663.97l.17.316.029.061 1.383 3.267a.8.8 0 0 1 .06.293v4.196c0 1.394-1.27 2.345-2.597 2.345h-1.764a3.033 3.033 0 0 1-6.046.124H2.8a.75.75 0 1 1 0-1.5h1.837a3.03 3.03 0 0 1 2.784-1.83 3.03 3.03 0 0 1 2.724 1.706h2.067c.713 0 1.097-.477 1.097-.845v-3.544H2.8a.75.75 0 1 1 0-1.5h2.023l-.977-3.265h-.978a.75.75 0 1 1 0-1.5h7.959l.107.005a2.02 2.02 0 0 1 .854-1.278c.398-.275.894-.436 1.274-.569l.098-.026 3.511-.718a.8.8 0 0 1 .261-.008zM7.421 16.335a1.533 1.533 0 1 0 0 3.064 1.533 1.533 0 0 0 0-3.064m-1.032-5.683h6.497l-.888-2.094c-.241-.451-.395-.735-.581-.931-.144-.151-.297-.24-.589-.24H5.412z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.461 8.406a.75.75 0 1 1 1.478.258l-.045.224c-.407 1.771-1.861 2.854-3.363 3.5l.716.308.068.034a.75.75 0 0 1-.661 1.344l-2.327-1a.75.75 0 0 1-.441-.826l.428-2.3a.75.75 0 0 1 1.475.274l-.172.92c1.482-.563 2.622-1.453 2.846-2.735z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const PowerClosingDoorIcon = ForwardRef;